import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import type { Theme } from '@mui/material';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { colors } from '../../../../../utils/theme';

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    textAlign: 'center',
    '& .MuiDialog-paper': {
      alignItems: 'center',
      padding: `${theme.spacing(2)} 0 ${theme.spacing(10)} 0`,
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: theme.spacing(1),
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 560,
    },
  },
  title: {
    '& .MuiTypography-root': {
      fontSize: 24,
      fontWeight: 500,
      marginTop: theme.spacing(4),
    },
  },
  content: {
    width: '60%',
    '& .MuiTypography-root': {
      fontSize: 16,
      fontWeight: 500,
    },
  },
  iconClose: {
    display: 'flex',
    width: '90%',
    justifyContent: 'end',
    '& .MuiSvgIcon-root': {
      fontSize: '28px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: colors.LIGHT_GREY,
        borderRadius: theme.spacing(0.5),
      },
    },
  },
}));

const ErrorDialog = () => {
  const classes = useStyle();

  const onCloseDialog = () => {
    return false;
  };

  const data = {
    title: 'Error',
    content: 'Something went wrong. Please try again later.',
  };

  return (
    <Dialog open={false} className={classes.root} onClose={onCloseDialog}>
      <div className={classes.iconClose}>
        <CloseIcon onClick={onCloseDialog} />
      </div>
      <DialogTitle>
        <div className={classes.title}>
          <img src="/assets/icons/errorIcon.svg" alt="error" />
          <Typography>{data && data.title}</Typography>
        </div>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography>{data && data.content}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
